import React from 'react'
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import {Card, Button} from 'react-bootstrap'


export default function ReferenceCard(props) {
  return (
    <div className="mb-3">
      <Card className='d-flex justify-content-center align-items-center' style={{ width:'13rem', height:'6rem', border:'1px solid black'}}>
      <Card.Body>
        <div className='d-flex justify-content-center align-items-center gap-2'>
          <Card.Title style={{marginTop:'4px'}}>{props.cardTitle}</Card.Title>
          <Card.Img src={props.cardImage} style={{ width: "40px", height: "40px", marginBottom:'7px' }}/>
        </div>
        <Button variant="dark" href={props.cardLink}>{props.cardText}</Button>
      </Card.Body>
    </Card> 
    </div>
  )
}





    // <a href="https://www.flaticon.com/free-icons/book" title="book icons">Book icons created by mikan933</a>



    // <div className="rounded-3" style={{backgroundColor:'white', border:'2px solid black',  width:'17rem', height:'6rem'}}>
    //     <div class="d-flex align-items-center" style={{borderBottom:'2px solid black'}}>
    //       <div className='flex-fill d-flex justify-content-center align-items-center pt-1' style={{width:'60', height:'60'}}><h2>Book</h2></div>
    //       <div className='flex-fill text-end d-flex justify-content-center align-items-center'><img src="./images/book.png" alt="Picture" height="40" width="40"/></div>
    //     </div>
    //     <div className=' d-flex justify-content-center' style={{paddingTop:'5px'}}>
    //       <Button variant="dark" title="book icons" href="https://www.flaticon.com/free-icons/book">Book icons created by mikan933</Button>
          
    //       </div>
    //   </div>